import { Link } from 'react-router-dom';

export default function AppFooter() {
  return (
    <footer className="border-t border-white/10 bg-base/70 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-4 py-5 md:px-8">
        <div className="flex flex-col items-center gap-4 md:flex-row md:items-center md:justify-between">
          {/* Left: Logo */}
          <Link
            to="/"
            className="font-marker text-xl tracking-wide text-amber drop-shadow-[0_0_8px_rgba(245,166,35,0.35)] transition-transform hover:scale-105"
          >
            OMore
          </Link>

          {/* Middle: Email + Instagram */}
          <div className="flex items-center gap-3">
            <a
              href="mailto:look@omore.app"
              className="font-gill text-xs text-ink/60 transition-colors hover:text-amber"
            >
              look@omore.app
            </a>
            <a
              href="https://www.instagram.com/omore.app/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="OMore on Instagram"
              className="flex h-7 w-7 items-center justify-center rounded-full border border-white/10 bg-white/5 text-ink/60 transition-colors hover:border-amber/40 hover:text-amber"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
              </svg>
            </a>
          </div>

          {/* Right: Links stacked vertically */}
          <nav className="flex flex-col items-end gap-1">
            <Link
              to="/safety"
              className="px-2 py-0.5 font-gill text-xs text-ink/60 transition-colors hover:text-amber"
            >
              Safety
            </Link>
            <Link
              to="/terms"
              className="px-2 py-0.5 font-gill text-xs text-ink/60 transition-colors hover:text-amber"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="px-2 py-0.5 font-gill text-xs text-ink/60 transition-colors hover:text-amber"
            >
              Privacy
            </Link>
            <a
              href="https://parent.omore.app"
              target="_blank"
              rel="noopener noreferrer"
              className="px-2 py-0.5 font-gill text-xs text-amber/80 transition-colors hover:text-amber"
            >
              Parent Dashboard
            </a>
          </nav>
        </div>

        <p className="mt-4 text-center font-gill text-xs text-ink/30">
          © {new Date().getFullYear()} OMore. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
